import { render } from "./CreateEditDatasources.vue?vue&type=template&id=d2ae0070&scoped=true"
import script from "./CreateEditDatasources.vue?vue&type=script&lang=js"
export * from "./CreateEditDatasources.vue?vue&type=script&lang=js"

import "./CreateEditDatasources.vue?vue&type=style&index=0&id=d2ae0070&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2ae0070"],['__file',"src/components/CreateEditDatasources.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d2ae0070"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d2ae0070', __exports__)) {
    api.reload('d2ae0070', __exports__)
  }
  
  module.hot.accept("./CreateEditDatasources.vue?vue&type=template&id=d2ae0070&scoped=true", () => {
    api.rerender('d2ae0070', render)
  })

}


export default __exports__